module.exports = __webpack_public_path__ + "img/np_notification.227201e8.svg";